/**
 * Per-zone-kind style properties — fill/outline mode, opacity, colors,
 * unmitigated-priority behaviour. Persisted in localStorage `qtr-zone-styles`.
 */
export const ZONE_KINDS = [
  { key: "ZII", label: "ZII (Zones Institutionnelles)" },
  { key: "ZRI", label: "ZRI (Zones de Rejet)" },
  { key: "DP", label: "DP (Décalages de Prix)" },
  { key: "OB", label: "Order Blocks" },
  { key: "BB", label: "Breaker Blocks" },
  { key: "FVG", label: "Fair Value Gaps" },
  { key: "CRT", label: "CRT (Candle Range)" },
];

export const DEFAULT_ZONE_STYLES = {
  ZII: { mode: "both", opacity: 0.13, bull: "#007aff", bear: "#ff3b30" },
  ZRI: { mode: "both", opacity: 0.15, bull: "#8b5cf6", bear: "#8b5cf6" },
  DP: { mode: "both", opacity: 0.18, bull: "#f5a623", bear: "#f5a623" },
  OB: { mode: "both", opacity: 0.14, bull: "#4682b4", bear: "#f43f5e" },
  BB: { mode: "both", opacity: 0.16, bull: "#fb923c", bear: "#d946ef" },
  FVG: { mode: "both", opacity: 0.14, bull: "#34d399", bear: "#fb7185" },
  CRT: { mode: "both", opacity: 0.12, bull: "#3b82f6", bear: "#d946ef" },
  unmitigated: { priority: true, action: "dim" },
};

const LS_KEY = "qtr-zone-styles";

export function loadZoneStyles() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      const merged = { ...DEFAULT_ZONE_STYLES };
      Object.keys(merged).forEach((k) => {
        if (parsed[k]) merged[k] = { ...merged[k], ...parsed[k] };
      });
      return merged;
    }
  } catch { /* noop */ }
  return DEFAULT_ZONE_STYLES;
}

export function saveZoneStyles(styles) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(styles)); } catch { /* noop */ }
}

export function hexToRgba(hex, alpha = 1) {
  if (!hex || !hex.startsWith("#")) return hex;
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

/**
 * Resolve fill/stroke for a zone given its kind style + mitigated status.
 * Returns null when the zone must be hidden (unmitigated priority = hide).
 */
export function zonePaint(zoneStyles, kind, direction, mitigated) {
  const s = zoneStyles[kind] || DEFAULT_ZONE_STYLES[kind];
  const um = zoneStyles.unmitigated || DEFAULT_ZONE_STYLES.unmitigated;
  let dim = 1;
  if (um.priority && mitigated === true) {
    if (um.action === "hide") return null;
    dim = 0.35;
  }
  const base = direction === "bear" || direction === "bear_flip" ? s.bear : s.bull;
  const fill = s.mode === "outline" ? "none" : hexToRgba(base, s.opacity * dim);
  const stroke = s.mode === "fill" ? "none" : hexToRgba(base, Math.min(1, 0.6 * dim + 0.1));
  return { fill, stroke, dimmed: dim < 1 };
}
